import React from 'react';

import { Link } from 'react-router-dom';

import { Button } from '@shared/components/ui';


const HOME_LOGO = '/icons/conway-512.png';

const HeroSection: React.FC = () => {
  const scrollToAreas = () => {
    document.getElementById('areas')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="flex min-h-[80vh] flex-col items-center justify-center px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl text-center">
        {/* Rounded because the mark is a full-bleed maskable tile; unrounded it
            reads as a hard square against the page. */}
        <img
          src={HOME_LOGO}
          alt="Conway"
          className="mx-auto mb-4 h-24 w-24 rounded-[22%] md:h-32 md:w-32"
        />
        <h1 className="text-foreground text-4xl font-light sm:text-5xl lg:text-6xl">
          Your
          <br />
          <strong className="font-semibold">AI Life OS</strong>
        </h1>
        <p className="text-muted-foreground mx-auto mt-6 max-w-2xl text-lg leading-relaxed sm:text-xl">
          Every area of your life gets its own AI — your mail, your money, your food, your health.
          The interesting part is what happens when they start comparing notes.
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link to="/signin">
            <Button variant="primary" size="lg">
              Get Started
            </Button>
          </Link>
          <Button variant="secondary" size="lg" onClick={scrollToAreas}>
            See How It Works
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
